/**
 * Vuex module for parked calls
 */
import API from '@/api'
import events from 'Store/events'
import debug from 'debug'
import ParkedCall from 'Store/class/parked_call'
import Parking from 'Store/class/parking'
import Vue from 'vue'

const dbg = debug('store:action:parking:')
const emptySlot = (space) => {
  return { isFree: true, Space: space }
}

const actions = {
  get: function ({ commit }) {
    dbg('loading parkings')
    API.getParkings().then(resp => {
      const parkings = resp?.data || []
      commit('SET_PARKINGS', parkings)
      for (const parking of parkings) {
        for (const call of parking.parked_calls || []) {
          commit('NEW_PARKED_CALL', call)
        }
      }
    }).catch(err => {
      dbg(err)
      const msg = API.getException(err) || 'Failed to get parkings'
      events.pubError(msg)
    })
  },

  update: function ({ commit }, data) {
    dbg(`New parking event: ${data.event}`)
    const event = data.event.toUpperCase()
    switch (event) {
      case 'PARKEDCALL':
        commit('NEW_PARKED_CALL', data)
        break
      case 'UNPARKEDCALL':
      case 'PARKEDCALLGIVEUP':
      case 'PARKEDCALLTIMEOUT':
        commit('PARKED_CALL_PICKUP', data)
        break
      case 'PARKEDCALLSWAP':
        commit('PARKED_CALL_SWAP', data)
        break
      default:
        dbg(`Unknown parking event ${event}. Ignore.`)
        break
    }
  }
}

const mutations = {
  SET_PARKINGS (state, parkings) {
    state.parkings = []
    for (const parking of parkings) {
      state.parkings.push(new Parking(parking))
    }
  },

  // used in testing
  RESET_SLOTS (state) {
    state.parkings.splice(0)
  },

  NEW_PARKED_CALL (state, data) {
    dbg(`New parked call event: ${data}`)
    const parkedCall = new ParkedCall(data)
    for (let parkingIndex = 0; parkingIndex < state.parkings.length; parkingIndex++) {
      for (let slotIndex = 0; slotIndex < state.parkings[parkingIndex].slotsObject.length; slotIndex++) {
        if (parkedCall.Space > 0 && ~~state.parkings[parkingIndex].slotsObject[slotIndex].Space === ~~parkedCall.Space) {
          Vue.set(state.parkings[parkingIndex].slotsObject, slotIndex, parkedCall)
        }
      }
    }
  },

  PARKED_CALL_PICKUP (state, data) {
    const parkingSpace = data.parkingspace
    for (let parkingIndex = 0; parkingIndex < state.parkings.length; parkingIndex++) {
      const idx = state.parkings[parkingIndex].slotsObject.findIndex(slot => !slot.isFree && slot.match(data))
      if (idx > -1) {
        Vue.set(state.parkings[parkingIndex].slotsObject, idx, emptySlot(parkingSpace))
      }
    }
  },

  PARKED_CALL_SWAP (state, data) {
    for (let parkingIndex = 0; parkingIndex < state.parkings.length; parkingIndex++) {
      for (let slotIndex = 0; slotIndex < state.parkings[parkingIndex].slotsObject.length; slotIndex++) {
        const slot = state.parkings[parkingIndex].slotsObject[slotIndex]
        !slot.isFree && slot.swapChan(data)
      }
    }
  }
}

const state = {
  parkings: []
}

const getters = {
  parkings: state => state.parkings,
  callsNum: state => state.parkings.reduce((total, entry) => total + entry.slotsObject.filter(slot => !slot.isFree).length, 0)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
